import { toast } from 'react-toastify'

export default {
  ValidateFormNew(form,message,is_lite=false){
     if(form.name.trim() === ""){
      toast.warning("Name is empty!")
      return false
    } else if(form.description.trim() === "") {
      toast.warning("Description is empty!")
      return false
    } else if((form.contact === "" || form.contact === undefined || form.contact === null) && !is_lite){
      toast.warning("Contact is empty!")
      return false
    } else if(form.site === "" || form.site === undefined || form.site === null){
      toast.warning("Site is empty!")
      return false
    }
    return true
  },
  ValidateForm(form,message){
    if(form.Name.trim() === ""){
      toast.warning(message.ERROR.MODEL.LOCATION.FORM.VALIDATION.NAME_EMPTY)
      return false
    }else if(form.ContactAlias.trim() === ""){
      toast.warning(message.ERROR.MODEL.LOCATION.FORM.VALIDATION.CONTACT_EMPTY)
      return false
    }else if(form.SiteAlias.trim() === ""){
      toast.warning(message.ERROR.MODEL.LOCATION.FORM.VALIDATION.SITE_EMPTY)
      return false
    }
    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/location/location/helper/form.js